export default __webpack_public_path__ + "static/media/emptyTracking.aa0e228d.svg";